<div class="modal-header justify-content-center">
  <h4 class="modal-title" id="myModalLabel">{{header | titlecase}}</h4>
</div>
<div class="modal-body">
  <form [formGroup]="formSerie">
    <div class="row">
      <div class="col-3">
        <div class="md-form">
          <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="seriedescription" maxlength="3" formControlName="description" placeholder="" class="form-control form-control-sm">
          <label for="seriedescription">Descripción</label>
          <mdb-error *ngIf="formSerie.controls.description.invalid && (formSerie.controls.description.dirty || formSerie.controls.description.touched)">
            Campo obligatorio
          </mdb-error>
        </div>
      </div>
      <div class="col">
        <div class="md-form">
          <input mdbInput mdbValidate [validateSuccess]="false" type="text" id="serieextend_description" formControlName="extend_description" placeholder="" class="form-control form-control-sm">
          <label for="serieextend_description">Descripción Extendida</label>
          <mdb-error *ngIf="formSerie.controls.extend_description.invalid && (formSerie.controls.extend_description.dirty || formSerie.controls.extend_description.touched)">
            Campo obligatorio
          </mdb-error>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <mdb-checkbox formControlName="default" [default]="true">Predeterminada</mdb-checkbox>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer text-center">
  <button mdbBtn type="button" size="sm" color="default" mdbWavesEffect (click)="submit()">
    <mdb-icon fas icon="check"></mdb-icon>
  </button>
  <button mdbBtn type="button" size="sm" color="light" mdbWavesEffect (click)="modalRef.hide()">
    <mdb-icon fas icon="undo"></mdb-icon>
  </button>
</div>
